import {Card} from "@/components/card/Card.tsx";
import {StatusPill} from "@/components/statusPill/StatusPill.tsx";
import {PillStatus} from "@/components/statusPill/StatusPill.types.ts";

import type {ComponentDrilldownResult} from "../../types.ts";

import styles from "./DrilldownComponentHeader.module.scss";

interface DrilldownComponentHeaderProps {
  drilldown: ComponentDrilldownResult;
}

export const DrilldownComponentHeader = ({drilldown}: DrilldownComponentHeaderProps) => {
  const pillStatus = drilldown.is_up
    ? PillStatus.UP
    : drilldown.current_status === "paused"
      ? PillStatus.PAUSED
      : drilldown.current_status === "maintenance"
        ? PillStatus.MAINTENANCE
        : PillStatus.DOWN;

  return (
    <Card variant="white" className={styles.componentCard}>
      <div className={styles.componentHeader}>
        <div className={styles.componentInfo}>
          <div className={styles.componentName}>{drilldown.component_name}</div>
          <div className={styles.componentMeta}>
            {drilldown.check_type_display && <span className={styles.metaText}>{drilldown.check_type_display}</span>}
            {drilldown.check_type_display && drilldown.address && <div className={styles.metaDivider} />}
            {drilldown.address && <span className={styles.metaText}>{drilldown.address}</span>}
            {(drilldown.check_type_display || drilldown.address) && <div className={styles.metaDivider} />}
            <StatusPill type="checks" status={pillStatus} variant="textAndIcon" />
          </div>
        </div>
      </div>
    </Card>
  );
};
